import { useLocation } from "react-router";

const useCurrentRoute = () => {
  const location = useLocation();
  const route = location.pathname.replace(/^\//, "");
  return route;
};

export default useCurrentRoute;
